var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDialogUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "66px",
    viewBox: "0 0 63 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3E55BACE-1F21-4EF1-A8B5-119A03F432CD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "18.9956632%",
    y1: "0%",
    x2: "86.2127723%",
    y2: "90.5346689%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE95D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB848",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Working",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter---Lock-Modal-SD",
    transform: "translate(-155.000000, -108.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(157.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CCCCCC",
    strokeWidth: 4,
    x: 0,
    y: 23.9396226,
    width: 39.6190476,
    height: 36.8301887,
    rx: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.0190476,
    y1: 18.7220126,
    x2: 52.4190476,
    y2: 20.2566038,
    id: "Line-18",
    stroke: "#CCCCCC",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.1047619,
    y1: 12.2767296,
    x2: 55.4666667,
    y2: 7.36603774,
    id: "Line-19",
    stroke: "#CCCCCC",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.8380952,
    y1: 7.36603774,
    x2: 43.8857143,
    y2: 1.22767296,
    id: "Line-20",
    stroke: "#CCCCCC",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92380952,23.783075 L7.92380952,9.85247667 C8.30432552,3.42205585 12.0807587,0.139234347 19.2531091,0.00401217153 C26.4254594,-0.131210004 30.4050547,3.15161149 31.1918948,9.85247667 L31.1918948,15.2379827",
    id: "Path-11",
    stroke: "#CCCCCC",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#CCCCCC",
    cx: 19.8095238,
    cy: 38.9786164,
    rx: 4.57142857,
    ry: 4.60377358
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 17.6761905,
    y: 40.5132075,
    width: 4.26666667,
    height: 10.4352201,
    rx: 2.13333333
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-Copy-2",
    fill: "url(#linearGradient-1)",
    points: "44.5 58.7227609 34.8015433 63.8487804 36.6796897 53.0409729 28.8075675 45.4012196 39.6667824 43.8476467 44.5 34 49.3332176 43.8476467 60.1924325 45.4012196 52.3203103 53.0409729 54.1984567 63.8487804"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogUpgrade);
export default __webpack_public_path__ + "static/media/dialog-upgrade.ee4f74d6b29440c1672032d8b47c662f.svg";
export { ForwardRef as ReactComponent };